import {Navigate} from 'react-router-dom';

import {restrictedAreaRoutes} from '@dms/routes';

export function Navigator() {
  return <Navigate replace to={restrictedAreaRoutes.home} />;
}
